import { style } from "typestyle";
import { colours } from "./colours";

export const formStyle = style({
  background: "white",
  border: `1px solid ${colours.lightBorder}`,
  borderRadius: "6px",
});